function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect } from 'react';
import { getIsStringDragAndDropFormat } from "../utilities/drag-and-drop.js";

/**
 * Drag hook for making an HTML element draggable.
 *
 * NOTE: For iOS Safari, dragging is enabled via long press.
 *
 * @example
 * const ref = useRef<HTMLDivElement | null>(null);
 * const { dragging } = useDrag({ data, format: 'custom', ref });
 * <div ref={ref}>Drag</div>
 *
 * @param options UseDragOptions<T>
 * @returns UseDragReturn
 */
var useDrag = function useDrag(options) {
  var data = options.data,
    _options$disabled = options.disabled,
    disabled = _options$disabled === void 0 ? false : _options$disabled,
    dragImageRef = options.dragImageRef,
    _options$effectAllowe = options.effectAllowed,
    effectAllowed = _options$effectAllowe === void 0 ? 'uninitialized' : _options$effectAllowe,
    format = options.format,
    ref = options.ref;
  var dragImage = dragImageRef === null || dragImageRef === void 0 ? void 0 : dragImageRef.current;
  var htmlElement = ref === null || ref === void 0 ? void 0 : ref.current;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dragging = _useState2[0],
    setDragging = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mounted = _useState4[0],
    setMounted = _useState4[1];
  useEffect(function () {
    setMounted(true);
  }, []);
  useEffect(function () {
    if (disabled || !mounted || !htmlElement || !htmlElement.addEventListener) {
      if (disabled && mounted && htmlElement) {
        htmlElement.removeAttribute('draggable');
      }
      return;
    }
    htmlElement.setAttribute('draggable', 'true');
    var onDragStart = function onDragStart(e) {
      var _e$dataTransfer2, _htmlElement$ondragst;
      // allows child draggable to be dragged inside parent draggable
      e.stopPropagation();
      if (dragImage) {
        var _e$dataTransfer;
        var parent = dragImage.getBoundingClientRect();
        var child = htmlElement.getBoundingClientRect();
        var x = child.left - parent.left + (e.clientX - child.left);
        var y = child.top - parent.top + (e.clientY - child.top);
        (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 || _e$dataTransfer.setDragImage(dragImage, x, y);
      }
      var isString = getIsStringDragAndDropFormat(format);
      (_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 || _e$dataTransfer2.setData(format, isString ? data : JSON.stringify(data));
      if (e.dataTransfer && effectAllowed !== 'uninitialized') {
        e.dataTransfer.effectAllowed = effectAllowed;
      }
      setDragging(true);
      (_htmlElement$ondragst = htmlElement.ondragstart) === null || _htmlElement$ondragst === void 0 || _htmlElement$ondragst.call(htmlElement, e);
    };
    var onDragEnd = function onDragEnd(e) {
      var _htmlElement$ondragen;
      setDragging(false);
      (_htmlElement$ondragen = htmlElement.ondragend) === null || _htmlElement$ondragen === void 0 || _htmlElement$ondragen.call(htmlElement, e);
    };
    htmlElement.addEventListener('dragstart', onDragStart);
    htmlElement.addEventListener('dragend', onDragEnd);
    return function () {
      htmlElement.removeEventListener('dragstart', onDragStart);
      htmlElement.removeEventListener('dragend', onDragEnd);
    };
  }, [data, disabled, dragImage, effectAllowed, format, htmlElement, mounted]);
  return {
    dragging: dragging
  };
};
export { useDrag };